import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseMainResidentList.module.scss'

import MyhouseMainResidentItem from '@Components/atoms/MyhouseMainResidentItem'
import MyHouseReviewSummaryResponse from '@Types/entities/MyHouseReviewSummaryResponse'
import useBoard from '@Hooks/myhouse/board/useBoard'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'

const cx = className.bind(style)

type Props = {
  list: MyHouseReviewSummaryResponse[]
  complexNo: number
}

const MyhouseMainResidentList: React.FC<Props> = ({ list, complexNo }: Props) => {
  const { isRecent, isVisited, getSimplifiedDate } = useBoard()
  const itemList = list

  return (
    <>
      {itemList && (
        <ul className={cx('myhouse_resient_list')}>
          {itemList?.map(({ sequence, content, userNickName, modifiedDate, readCount, imageUrl }) => {
            const reviewItem = {
              title: content,
              nickName: userNickName,
              isRecent: isRecent(modifiedDate),
              isVisited: isVisited(sequence),
              date: getSimplifiedDate(modifiedDate),
              reviewCount: readCount,
              imageUrl: imageUrl,
              href: `${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/${complexNo}/reviews/${sequence}`,
            }

            return <MyhouseMainResidentItem key={sequence} {...reviewItem} />
          })}
        </ul>
      )}
    </>
  )
}

export default MyhouseMainResidentList
